// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAcceptedStatusCard_root__oqCs-","text":"PlasmicAcceptedStatusCard_text__WBjQD"};